import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ELogLevel } from 'shared/enum';
import { logger } from 'shared/utils/logger';
import { translationInit } from 'shared/utils/translation';

import App from './App';

const rootElement = document.getElementById('app');

if (!rootElement) throw new Error('Root element #app not found');

const renderApp = () => {
  ReactDOM.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>,
    rootElement,
  );
};

translationInit()
  .then(renderApp)
  .catch(err => logger(err, ELogLevel.ERROR));
